import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmEmailAction } from "../../store/actions/loginActions";
import ModalComponent from "../../components/Modals/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const CONFIRM_EMAIL_ERROR_MESSAGE =
  "The verification code is invalid or has expired. Please try again.";

const ConfirmEmail = () => {
  // verification code
  const [verificationcode, setverificationcode] = useState();
  //history for routing
  const history = useNavigate();
  // dispatch actions
  const dispatch = useDispatch();
  // getting error
  const { loginError } = useSelector((state) => state.loginReducer);

  // email and user id from params
  const { email, phone } = useParams();
  // verification cide
  const [verificationcodeActive, setverificationcodeActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attemptCompleted, setAttemptCompleted] = useState(false);
  // modal for errors/messages
  const [modalFields, setModalFields] = useState({
    open: false,
    text: "",
    btnText1: "Ok",
    closeFunc: () => setModalFields((prev) => ({ ...prev, open: false })),
  });
  // forgot password
  const handleConfirmEMail = async () => {
    if (!verificationcode) {
      setModalFields((prev) => ({ ...prev, open: true, text: "Please fill all the fields" }));
      return;
    }

    setAttemptCompleted(false);
    try {
      setLoading(true);
      const result = await dispatch(ConfirmEmailAction(email, verificationcode, history));
      console.log("result from confirm email action", result);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setAttemptCompleted(true);
      
    }
  };

  // show error only after the current API attempt has completed
  React.useEffect(() => {
    try {
      if (attemptCompleted && !loading && loginError) {
        setModalFields((prev) => ({ ...prev, open: true, text: CONFIRM_EMAIL_ERROR_MESSAGE }));
      }
    } catch (err) {
      console.error(err);
    }
  }, [attemptCompleted, loading, loginError]);

  return (
    <div
      className="flex items-start justify-center px-4 w-full pt-6 pb-4"
      style={{ minHeight: "calc(100vh - 60px)" }}
    >
      <div className="w-full max-w-container mx-auto">
        <div className="flex flex-col items-start gap-1 mb-4">
          <h1 className="text-[#211F59] text-2xl font-semibold">
            Verify your email
          </h1>
          <div className="text-[14px] text-[#211F59]">
            A verification code has been sent to your email {email} and
            cellphone {phone}. Please enter that code below:
          </div>
        </div>

        <div className="mb-2">
          <div className="bg-[#E6E6E6] rounded-[12px] h-[48px] flex items-center">
            <input
              placeholder="Code"
              value={verificationcode || ""}
              onFocus={() => setverificationcodeActive(true)}
              onChange={(e) => setverificationcode(e?.target?.value)}
              className="w-full bg-transparent placeholder:text-[#373559] placeholder:text-[14px] pl-[13.5px] h-[48px] rounded-[12px] border-[1px] border-transparent focus:border-[#7876A1] outline-none"
            />
          </div>
        </div>

        {/* error modal will show API errors */}

        <div className="mt-4 space-y-3">
          <button
            onClick={handleConfirmEMail}
            disabled={loading}
            aria-busy={loading}
            className="w-full bg-[#34318C] text-white rounded-[15px] h-[48px] px-6 flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? (
              <Box sx={{ display: "flex" }}>
                <CircularProgress size={18} color="inherit" />
              </Box>
            ) : (
              "Confirm Email"
            )}
          </button>

          <div className="flex items-center text-[12px] justify-between mt-3">
            <span className="text-[#7876A1]">
              Back to{" "}
              <span
                className="text-[##7876A1] font-bold underline cursor-pointer"
                onClick={() => history("/Login")}
              >
                Sign in
              </span>
            </span>

            <span>
              Don’t have an account?{" "}
              <span
                className="text-[#211F59] font-bold underline cursor-pointer"
                onClick={() => history("/Signup")}
              >
                Sign up
              </span>
            </span>
          </div>
        </div>
        <ModalComponent
          text={modalFields.text}
          openState={modalFields.open}
          closeFunction={() => setModalFields((prev) => ({ ...prev, open: false }))}
          btnText1={modalFields.btnText1}
          btnClickFunc1={modalFields.closeFunc}
        />
      </div>
    </div>
  );
};

export default ConfirmEmail;
